
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import FormLabel from "@mui/material/FormLabel";
import DialogActions from '@mui/material/DialogActions';


const MergeTeamModal = ({
    mergeTeamDialogOpen,
    teamInfo,
    handleTeamName,
    mergeToValue,
    dataWithTeamSelected,
    recLeadRequisitionData,
    handleRecruiterSelection,
    saveHandleMerge,
    isUserDataUpdating,
    handleMergeTeamDialogClose,
    handleMergeToChange
}) => {
    return (
        <Dialog
            open={mergeTeamDialogOpen}
            aria-labelledby="customized-dialog-title"
            maxWidth="md"
            fullWidth
        >
            <div className="team_dialog_modal">
                <div className="team-dialog-TitleContainer">
                    <span className="dialog-title-text">
                        Merge Team
                    </span>
                </div>
            </div>
            <DialogContent>
                <div className="dialogboxMergedTeam">
                    <div>
                        <Grid size={{ xs: 12 }}>
                            <Typography className="field-title-team-dialog">
                                Merge From
                            </Typography>
                            <TextField
                                fullWidth
                                variant="outlined"
                                className="input-field-team-dialog_mergedTeam"
                                placeholder="Merge From"
                                value={teamInfo.teamName}
                                onChange={handleTeamName}
                                disabled
                            />
                        </Grid>
                    </div>
                    <div>
                        <Grid size={{ xs: 12 }}>
                            <Typography className="field-title-team-dialog">
                                Merge To *
                            </Typography>
                            <Autocomplete
                                id="combo-box-demo"
                                className="mergeToDialogbox"
                                options={dataWithTeamSelected}
                                getOptionLabel={(option) => option?.teamName || ""}
                                value={mergeToValue}
                                onChange={handleMergeToChange}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Merge To"
                                    />
                                )}
                            />
                        </Grid>
                    </div>

                </div>
                {mergeToValue ?
                    <>
                        <div className="contentOfMergedTeam">
                            <div className="fs-semi-bold f-color fs-18">
                                All the Requisition of {teamInfo?.recruitmentLeader?.email} and {teamInfo?.teamLeader?.email} of Team ({teamInfo?.teamName}) will be transfer to new team?
                            </div>
                            <div className="requisition-list-mergedTeam">
                                {recLeadRequisitionData &&
                                    recLeadRequisitionData.map((item) => (
                                        <span key={item._id} className="requisition-item-mergedTeam">{item.reqreferenceId}</span>
                                    ))}

                            </div>
                        </div>
                        <FormControl
                            component="fieldset"
                            variant="standard"
                            fullWidth
                            sx={{
                                mt: 2, 
                            }}
                        >
                            <FormLabel
                                sx={{
                                    mb: 1,
                                    fontWeight: 600,
                                    fontSize: "1rem",
                                    color: "text.primary",
                                    "&.Mui-focused": {
                                        color: "text.primary"
                                    }
                                }}
                            >
                                Recruiters to be Transferred
                            </FormLabel>

                            <FormGroup
                                sx={{
                                    display: "flex",
                                    flexDirection: "row", 
                                    flexWrap: "wrap",     
                                    gap: 1,               
                                }}
                            >
                                {teamInfo.allRecruiters.map((rec) => (
                                    <FormControlLabel
                                        key={rec.toString()}
                                        control={
                                            <Checkbox
                                                checked={rec.selected}
                                                onChange={() => handleRecruiterSelection(rec)}
                                                size="small"
                                                sx={{
                                                    "&:focus-visible": {
                                                        outline: "none",
                                                    },
                                                }}
                                            />
                                        }
                                        label={rec.email}
                                        sx={{
                                            "& .MuiFormControlLabel-label": {
                                                fontSize: "0.9rem",
                                            },
                                        }}
                                    />
                                ))}
                            </FormGroup>

                        </FormControl>


                    </>
                    : null
                }

            </DialogContent>
            <DialogActions>
                <div className='dialog-actionbutton-mergedteam-model'>

                    <button variant="contained" className="updateButton-team-model" onClick={() => saveHandleMerge()} disabled={isUserDataUpdating}
                    >
                        <div className="button_merged_team">
                            <span>Save</span>
                            {isUserDataUpdating ? (
                                <CircularProgress className="circularProgress_mergeButton_team" />
                            ) : null}
                        </div>

                    </button>
                    <button variant="contained" color="secondary" className='cancel-button-team' onClick={() => handleMergeTeamDialogClose()}
                    >
                        Cancel
                    </button>
                </div>
            </DialogActions>
        </Dialog>
    )
}

export default MergeTeamModal
